import { take, call, select, put } from 'redux-saga/effects';
import { AlarmId, DeviceMap, AlarmMap, DeviceIdMap, CellIndex, CellState } from 'types';
import { getAlarmMap } from 'selectors/alarmSelectors';
import { getDeviceIdByDeviceIndex, getDevices, isCamera } from 'selectors/deviceSelectors';
import { makeStreamId } from 'util/streamId';
import { assignStream, setStreamPosition, seek } from 'actions/monitoringActions';
import { getActiveCellIndex, getCell } from 'selectors/monitoringSelectors';

export function* displayAlarmWatcher() {
    while (true) {
        const action = yield take('DISPLAY_ALARM');
        const alarmId = action.payload;
        yield call(displayAlarmSaga, alarmId);
    }
}

export function* displayAlarmSaga(alarmId: AlarmId) {
    const alarmMap: AlarmMap = yield select(getAlarmMap);
    const deviceMap: DeviceMap = yield select(getDevices) || {};
    const deviceIdByDeviceIndex: DeviceIdMap = yield select(getDeviceIdByDeviceIndex);

    // Lookup the device in the Alarm
    const {
        deviceId: deviceIndexString,
        time: utcTime,
    } = alarmMap[alarmId];
    const deviceId = deviceIdByDeviceIndex[deviceIndexString];
    const device = deviceMap[deviceId];
    if (!device) {
        // Bail out because device no longer exists
        return;
    }

    const streamId = makeStreamId(deviceId, 0);
    const cellIndex: CellIndex = yield select(getActiveCellIndex);

    //
    // Load the camera into the active cell if it isn't already there.
    // (Note: some alarms are generated by non-camera devices.)
    //
    if (isCamera(device)) {
        const cell: CellState = yield select(getCell, { cellIndex });
        if (cell.streamId !== streamId) {
            yield put(assignStream({ streamId, cellIndex, paused: true }));
            yield put(setStreamPosition(utcTime, { cellIndex }));
        }
    }

    // Seek to the time of the alarm
    yield put(seek({ cellIndex, utcTime }));
}



// WEBPACK FOOTER //
// ./src/sagas/alarms/displayAlarmSaga.ts